module.exports = __webpack_public_path__ + "static/media/loading.de451bba.gif";